import React from "react";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";

import ShoreBoundColumnDescription from "features/planner/report/helicopter/components/ShoreBound/ShoreBoundColumnDescription";
import OffshoreBoundColumnDescription from "features/planner/report/helicopter/components/OffshoreBound/OffshoreBoundColumnDescription";

const ShoreOffshoreBoundColumnDescriptions = ({
  classes,
  bookingSystemType,
}) => (
  <Grid container className={classes.root}>
    <Grid item xs={8}>
      <OffshoreBoundColumnDescription bookingSystemType={bookingSystemType} />
    </Grid>
    <Grid item xs={4} className={classes.shoreBound}>
      <ShoreBoundColumnDescription bookingSystemType={bookingSystemType} />
    </Grid>
  </Grid>
);

const styles = () => ({
  root: {
    borderTop: "none",
    background: grey[100],
    border: `1px solid ${grey[300]}`,
  },
  shoreBound: {
    borderLeft: `1px solid ${grey[300]}`,
  },
});

export default compose(withStyles(styles))(
  ShoreOffshoreBoundColumnDescriptions,
);
